namespace Portico.Tfs {
    export class TfsReleaseService {
        constructor(private $http: angular.IHttpService, private settings: ITfsSettings) {}

        private request<T>(method: string, url: string, data?: any): ng.IPromise<T> {
            url = `/${this.settings.project}/_apis/release/releases${url}`;
            return this.$http<T>(
                vsrmRequest({ method, url, data }, this.settings, '3.0-preview.1')
            ).then(x => x.data);
        }

        public list(criteria: Release.List.Request) {
            const items: string[] = [];
            for (let key of Object.keys(criteria)) {
                if (Array.isArray(criteria[key])) {
                    criteria[key] = criteria[key].join(',');
                }
                items.push(`${key}=${criteria[key]}`);
            }
            let url = `/`;
            if (items.length > 0) {
                url += '?' + items.join('&');
            }
            return this.request<Release.List.Response>('get', url);
        }

        public get(id: number, includeAllApprovals = true) {
            const url = `/${id}`;
            return this.request<Release.Get.Response>('get', url);
        }

        public update(id: number, request: Release.Get.UpdateRequest) {
            const url = `/${id}`;
            return this.request<Release.Get.Response>('patch', url, request);
        }

        public updateEnvironment(
            id: number,
            environment: number,
            request: Release.Get.UpdateEnvironmentRequest
        ) {
            const url = `/${id}`;
            return this.request<Release.Get.Environment>('patch', url, request);
        }
    }
}
